import { Vertical } from "@/components/Flex.ts"
import { ProjectCoverEditor } from "@/components/ProjectCoverEditor/ProjectCoverEditor.tsx"
import { ProjectNameEditor } from "@/components/ProjectSettingsDialog/ProjectNameEditor.tsx"
import { useProjectPermissions } from "@/routes/projects/projectHooks.ts"

import type { ProjectGeneralTabModel } from "@/components/ProjectSettingsDialog/ProjectGeneralTabModel.ts"


export const ProjectGeneralTab = ({ model }: {
  model: ProjectGeneralTabModel
}) => {
  const permissions = useProjectPermissions(model.project.key)
  const canEditProject = permissions.canEdit

  return (
    <Vertical gap="16px">
      <ProjectNameEditor model={model} canEditProject={canEditProject} />
      <ProjectCoverEditor model={model} canEditProject={canEditProject} />
    </Vertical>
  )
}
